import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';

@Component({
	selector: 'NgxRefresh',
	templateUrl: './ngxRefresh.component.html'
})
export class NgxRefresh {
	@Output() refreshPage = new EventEmitter();

	constructor() {

	}

	ngOnInit() {

	}

	onRefreshPage() {
		this.refreshPage.emit();
	}
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/shared/ngxGrid/ngxRefresh.component.ts